// extracted by mini-css-extract-plugin
export default {"external-rating-result-box":"index_external-rating-result-box__2YavH"};